import { Collection } from 'modules/core/lib/mobx-rest'
import type { SetOptions } from 'modules/core/lib/mobx-rest/types'

import type { ICustomFieldValue } from 'modules/custom_resources/store/models/customFields/Value'
import CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'

interface Config {
  model_ref: string
  instance_id?: number
}

class CustomFieldValues extends Collection<CustomFieldValue> {
  config: Config

  constructor(data: any, config: Config) {
    super(data)
    this.set(data)
    this.config = config
  }

  get cacheKey(): string {
    return 'customFieldValues'
  }

  get indexes() {
    return ['instance_id']
  }

  get dynamicPath() {
    const { instance_id, model_ref } = this.config

    return `/custom_fields/values/${model_ref}/${instance_id ?? 'all'}`
  }

  create(attributes: Partial<ICustomFieldValue>) {
    return super.create(attributes, { path: this.dynamicPath })
  }

  fetch(options: SetOptions = {}) {
    return super.fetch({ ...options, path: this.dynamicPath })
  }

  model() {
    return CustomFieldValue
  }
}

export default CustomFieldValues
